
import React from 'react';
import { Row, Col, Button } from 'antd';


interface StepProps {
    editClick: () => void;
}

export const NoDataForm = ({ editClick }: StepProps) => {
    return (
        <>
            <div className='w-full'>
                <Row justify="center">
                    何も登録されていません
                </Row>
                <Row justify="center" className='w-full mt-6'>
                    <Col span={12}>
                        <Button type="primary" size='large'
                            onClick={editClick}
                            style={{
                                height: '56px',
                                width: '100%'
                            }}
                            className='button-container'>
                            登録する
                        </Button>
                    </Col>
                </Row>
            </div >
        </>
    );
}